import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import FinSupplierAccountResponse from 'src/app/invopay/interfaces/fin-supplier-account-response';
import IpErrorResponse from 'src/app/invopay/interfaces/ip-error-response';
import { FnAccountFinanceService } from 'src/app/invopay/services/fn-account-finance.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';

@Component({
  selector: 'app-fn-block-card-modal',
  templateUrl: './fn-block-card-modal.component.html',
  styleUrls: ['./fn-block-card-modal.component.scss']
})
export class FnBlockCardModalComponent {
  blockReason = '';

  constructor(
    private fnAccountFinanceService: FnAccountFinanceService,
    private ipSnackbarService: IpSnackbarService,
    private dialogRef: MatDialogRef<FnBlockCardModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: FinSupplierAccountResponse,
  ) { }

  blockCard() {
    const subscribeFunctions = {
      next: () => {
        this.dialogRef.close(true);
      },
      error: (e: IpErrorResponse) => {
        this.ipSnackbarService.showErrorMessage(e);
      }
    };
    if (this.data?.supplierId) {
      this.fnAccountFinanceService
        .blockCardFromEnterprise(this.blockReason, this.data.supplierId)
        .subscribe(subscribeFunctions);
    }
    else {
      this.fnAccountFinanceService.blockCard(this.blockReason)
        .subscribe(subscribeFunctions);
    }
  }

  formatCardNumber(cardNumber: string): string {
    const cardNumberParts = [];
    for (let i = 0, j = 0; i < 4; i++) {
      cardNumberParts[i] = cardNumber.substring(j, j + 4);
      j += 4;
    }
    return '···· ' + cardNumberParts[3];
  }
}
